export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent';

interface ToneClasses {
    text: string;
    bg: string;
}

/** Shared by Chip and Badge so the two tone scales can never drift apart. */
export const TONE_CLASSES: Record<Tone, ToneClasses> = {
    neutral: { text: 'text-content-secondary', bg: 'bg-white/[0.08]' },
    success: { text: 'text-status-success', bg: 'bg-status-success/15' },
    warning: { text: 'text-status-warning', bg: 'bg-status-warning/15' },
    danger: { text: 'text-status-danger', bg: 'bg-status-danger/15' },
    info: { text: 'text-status-info', bg: 'bg-status-info/15' },
    accent: { text: 'text-[color:var(--zone-accent)]', bg: 'bg-[color:var(--zone-accent)]/15' },
};
